import { createFileRoute } from "@tanstack/react-router";
import { PageHeader, StatusPill } from "@/components/shared/Primitives";
import { FileBadge } from "lucide-react";

export const Route = createFileRoute("/portal/warranty")({
  component: Warranty,
});

const warranties = [
  {
    product: 'Aeroclass 48"',
    coverage: "25 month manufacturer",
    expires: "Sep 2028",
    status: "active",
  },
  {
    product: "Purevent 12",
    coverage: "15 month manufacturer",
    expires: "Nov 2027",
    status: "active",
  },
  {
    product: "Extension Cord 3+1",
    coverage: "90 day manufacturer",
    expires: "Nov 2026",
    status: "active",
  },
];

function Warranty() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Warranty claims"
        description="Active coverage on your purchases."
      />
      <div className="space-y-3">
        {warranties.map((w) => (
          <div
            key={w.product}
            className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5 shadow-elegant"
          >
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-gradient-primary/10 text-primary">
              <FileBadge className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-semibold">{w.product}</div>
              <div className="text-xs text-muted-foreground">
                {w.coverage} · expires {w.expires}
              </div>
            </div>
            <StatusPill value={w.status} />
            <button className="h-9 rounded-lg bg-gradient-primary px-3 text-xs font-medium text-primary-foreground">
              File a claim
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
